import { useState, useEffect, useRef } from "react";
import { setCookie, getCookieValue } from "@/utils/commonUtil";
import Para from "@/components/atoms/text/Para";
import Link from "next/link";

const EUROPEAN_COUNTRY_CODES = [
  "AL",
  "AD",
  "AT",
  "BY",
  "BE",
  "BA",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "EL",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "MD",
  "MC",
  "ME",
  "NL",
  "MK",
  "NO",
  "PL",
  "PT",
  "RO",
  "RU",
  "SM",
  "RS",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
  "TR",
  "UA",
  "GB",
  "UK",
];

const CookieBanner = ({ showBanner }) => {
  const [hideCookieBanner, setHideCookieBanner] = useState(true);
  const cookieBannerRef = useRef(null);

  useEffect(() => {
    const countryCode = getCookieValue("countryCode");
    if (EUROPEAN_COUNTRY_CODES.includes(countryCode)) {
      const isCookieBannerClosed = getCookieValue("isCookieBannerClosed");
      if (!isCookieBannerClosed) {
        setHideCookieBanner(false);
      }
    }
  }, []);

  const toggleCookieBanner = () => {
    setCookie("isCookieBannerClosed", true, 365);
    setHideCookieBanner(true);
  };

  if (hideCookieBanner || !showBanner) return null;

  return (
    <div ref={cookieBannerRef} className="cookie-banner bc-white w-100">
      <div className="container fx fx--ch">
        <Para className="mr-2">
          By using our site you accept our{" "}
          <Link className="text--link" href="/cookie-policy">
            Cookies Policy
          </Link>
          .
        </Para>
        <button
          type="button"
          className="btn btn--xs btn--ghost"
          onClick={toggleCookieBanner}
        >
          Ok
        </button>
      </div>
      <style jsx>{`
        .cookie-banner {
          padding: 14px 0;
          position: fixed;
          bottom: 0;
          left: 0;
          z-index: 4;
        }
        .cookie-banner .btn--xs {
          padding: 0 16px;
          @media (max-width: 749px) {
            font-size: 14px;
            padding: 0 10px;
          }
        }
        @media (max-width: 749px) {
          .cookie-banner {
            top: 68px;
            bottom: initial;
          }
          .cookie-banner .container {
            padding: 0 12px;
          }
        }
      `}</style>
    </div>
  );
};

export default CookieBanner;
